<!-- Custom Dialog Layout with Fixed Header -->
<div class="governorate-dialog-container">
  <!-- Fixed Header with Step Indicator and Error Messages -->
  <div class="fixed-header">
    <!-- Dialog Title Section -->
    <div class="dialog-title-section">
      <div class="flex justify-between items-start">
        <div>
          <h1 class="text-xl font-medium text-surface-on">
            {{ data.governorate ? 'Edit Governorate' : 'Add New Governorate' }}
          </h1>
          <p class="text-sm mt-2 text-surface-on">Enter the required data and save</p>
        </div>
        <button
          type="button"
          class="close-button"
          (click)="closeDialog()"
          aria-label="Close dialog"
        >
          <mat-icon svgIcon="close" class="w-6 h-6"></mat-icon>
        </button>
      </div>
    </div>

    <!-- Step Indicator -->
    <div class="step-indicator-fixed">
      <div class="flex items-center justify-center max-w-md mx-auto">
        @for (step of steps(); track step.key; let i = $index) {
          <div class="flex items-center">
            <div
              class="step-circle flex items-center justify-center w-8 h-8 rounded-full text-sm font-medium cursor-pointer transition-colors"
              [class.step-active]="i === currentStep()"
              [class.step-completed]="i < currentStep()"
              [class.step-pending]="i > currentStep()"
              [class.step-disabled]="i === 1 && isAreasStepDisabled()"
              (click)="goToStep(i)"
            >
              @if (i < currentStep()) {
                <mat-icon svgIcon="check" class="w-4 h-4"></mat-icon>
              } @else {
                {{ i + 1 }}
              }
            </div>
            <span
              class="ml-2 text-sm font-medium"
              [class.text-primary]="i === currentStep()"
              [class.text-gray-600]="i !== currentStep()"
              [class.text-gray-400]="i === 1 && isAreasStepDisabled()"
            >
              {{ step.label }}
            </span>
            @if (i < steps().length - 1) {
              <div class="w-16 h-px bg-gray-300 mx-6"></div>
            }
          </div>
        }
      </div>
    </div>

    <!-- Fixed Error Messages -->
    <div class="error-messages-fixed">
      @if (submitError()) {
        <div class="error-message text-error px-4 py-3 text-sm bg-error-50 border border-error-200 rounded-lg shadow-sm">
          <div class="flex items-center gap-2">
            <mat-icon svgIcon="alert-circle" class="w-4 h-4 flex-shrink-0"></mat-icon>
            <span>{{ submitError() }}</span>
          </div>
        </div>
      }

      @if (stepValidationErrors().length > 0) {
        <div class="error-message text-error px-4 py-3 text-sm bg-error-50 border border-error-200 rounded-lg shadow-sm">
          <div class="flex items-start gap-2">
            <mat-icon svgIcon="alert-circle" class="w-4 h-4 flex-shrink-0 mt-0.5"></mat-icon>
            <div class="space-y-1">
              @for (error of stepValidationErrors(); track error) {
                <div>{{ error }}</div>
              }
            </div>
          </div>
        </div>
      }

      @if (isAreasStepDisabled() && currentStep() === 0) {
        <div class="info-message text-blue-700 px-4 py-3 text-sm bg-blue-50 border border-blue-200 rounded-lg shadow-sm">
          <div class="flex items-center gap-2">
            <mat-icon svgIcon="info" class="w-4 h-4 flex-shrink-0"></mat-icon>
            <span>Save the governorate details first to manage areas</span>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Scrollable Content Area -->
  <div class="scrollable-content">
    <cac-dialog-layout
      [title]="''"
      [subtitle]="''"
      [hideControls]="true"
    >
      <!-- Step Content -->
      <div class="step-content min-h-96">
        <!-- Step: Governorate Details -->
        @if (steps()[currentStep()].key === 'governorate') {
          <div class="step-section">
            <div class="border rounded-lg shadow-sm border-gray-200 p-6">
              <cac-form-builder [options]="form"></cac-form-builder>
            </div>
          </div>
        }

        <!-- Step: Areas -->
        @if (steps()[currentStep()].key === 'areas') {
          <div class="step-section">
            <div class="border rounded-lg shadow-sm border-gray-200 p-6">
              <cac-table [options]="areasTable"></cac-table>
            </div>
          </div>
        }
      </div>
    </cac-dialog-layout>
  </div>

  <!-- Fixed Footer with Action Buttons -->
  <div class="fixed-footer">
    <div class="footer-actions">
      <div class="flex justify-between items-center">
        <div class="flex items-center gap-3">
          <cac-button
            *ngIf="canGoToPreviousStep()"
            (click)="previousStep()"
            appearance="stroked"
            icon="chevron-left"
          >
            Previous
          </cac-button>
        </div>
        
        <div class="flex items-center gap-3">
          <cac-button
            (click)="closeDialog()"
            appearance="text"
          >
            Cancel
          </cac-button>
          <cac-button
            (onClick)="onMainAction($event)"
            theme="primary"
          >
            {{ canSave() ? 'Save' : 'Next' }}
          </cac-button>
        </div>
      </div>
    </div>
  </div>
</div>
